import {
    Message
} from 'element-ui';
import request from '@/utils/request'
const util = {

    welcome: () => {
        const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
        const index = Math.floor(Math.random() * arr.length)
        return arr[index]
    },

    /***
     * 时间格式化
     * @param date 时间戳传数字 new Date()格式传字符串
     * @param fmt 需要格式化后的格式（yyyy-MM-dd hh:mm:ss）
     * @return {string}
     */
    formatDateQsb: (date, fmt) => {
        // eslint-disable-next-line no-undef
        if (!date) {
            return date
        }
        // eslint-disable-next-line no-redeclare
        var date = new Date(date)
        if (date.getFullYear() === 1970) {
            return '暂无'
        }
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        var o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        }
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                var str = o[k] + ''
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
            }
        }
        return fmt
    },

    /***
     * 时间格式化工具
     * @param timestamp 时间戳传数字 new Date()格式传字符串
     * @return {string}
     */
    timeFormatQsb(timestamp) {
        if (!timestamp) {
            return ''
        }
        var date = new Date(timestamp)
        if (date.getFullYear() === 1970) {
            return '暂无'
        }
        if (typeof timestamp === 'string') {
            timestamp = new Date(timestamp).getTime()
        }
        // 补全为13位
        var arrTimestamp = (timestamp + '').split('')
        for (var start = 0; start < 13; start++) {
            if (!arrTimestamp[start]) {
                arrTimestamp[start] = '0'
            }
        }
        timestamp = arrTimestamp.join('') * 1

        var minute = 1000 * 60
        var hour = minute * 60
        var day = hour * 24
        var month = day * 30
        var now = new Date().getTime()
        var diffValue = now - timestamp

        // 如果本地时间反而小于变量时间
        if (diffValue < 0) {
            return '不久前'
        }

        // 计算差异时间的量级
        var monthC = diffValue / month
        var weekC = diffValue / (7 * day)
        var dayC = diffValue / day
        var hourC = diffValue / hour
        var minC = diffValue / minute

        // 数值补0方法
        var zero = function (value) {
            if (value < 10) {
                return '0' + value
            }
            return value
        }

        // 使用
        if (monthC > 12) {
            // 超过1年，直接显示年月日
            return (function () {
                return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月' + zero(date.getDate()) +
                    '日'
            })()
        } else if (monthC >= 1) {
            return parseInt(monthC) + '月前'
        } else if (weekC >= 1) {
            return parseInt(weekC) + '周前'
        } else if (dayC >= 1) {
            return parseInt(dayC) + '天前'
        } else if (hourC >= 1) {
            return parseInt(hourC) + '小时前'
        } else if (minC >= 1) {
            return parseInt(minC) + '分钟前'
        }
        return '刚刚'
    },
    /***
     * 复制内容
     * @param 需要复制的内容 时间戳传数字 data格式传字符串
     */
    copyText(data) {
        const input = document.createElement('input') // js创建一个input输入框
        input.value = data // 将需要复制的文本赋值到创建的input输入框中
        document.body.appendChild(input) // 将输入框暂时创建到实例里面
        input.select() // 选中输入框中的内容
        document.execCommand('Copy') // 执行复制操作
        document.body.removeChild(input) // 最后删除实例中临时创建的input输入框，完成复制操作
        Message({
            message: '复制成功',
            type: 'success'
        })
    },

    // 批量导入题目
    batchImportQuestion: (file, programId, resourceId) => {

        const formData = new FormData()
        formData.append('file', file)
        formData.append('szCourseProgramId', programId)
        formData.append('resourceId', resourceId)
        return new Promise((resolve, reject) => {
            request({
                url: '/backend/courseExam/batchOperationCourseExam',
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': localStorage.getItem("admin-token")
                },
                data: formData
            }).then(res => {
                resolve(res)
                // eslint-disable-next-line handle-callback-err
            }).catch((err) => {
                Message.error('上传失败！')
            })
        })
    },

    // 上传图片接口
    uploadImage: (file) => {
        // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
        // const isLt2M = file.size / 1024 / 1024 < 5
        // if (!isJpgOrPng) {
        //     Message.error('图片格式不正确')
        //     return
        // }
        // if (!isLt2M) {
        //     Message.error('图片最大为5MB!')
        //     return
        // }
        const formData = new FormData()
        formData.append('file', file)
        return new Promise((resolve, reject) => {
            request.request({
                url: '/backend/upload/iv',
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'up_iv_account': 'UPLOAD_IMAGE_VIDEO_VALUE'
                },
                data: formData
            }).then(res => {
                resolve(res)
                // eslint-disable-next-line handle-callback-err
            }).catch((err) => {
                Message.error('图片上传失败！')
            })
        })
    },


    // 把文件转换为base64
    fileByBase64(file, callback) {
        let reader = new FileReader();
        // 传入一个参数对象即可得到基于该参数对象的文本内容
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            // target.result 该属性表示目标对象的DataURL
            callback(e.target.result);
        };
    },

    // 把base64转换为Canvas
    async imgToCanvas(base64) {
        // 创建img元素
        const img = document.createElement("img");
        img.setAttribute("src", base64);
        await new Promise((resolve) => (img.onload = resolve));
        // 创建canvas DOM元素，并设置其宽高和图片一样
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        // 坐标(0,0) 表示从此处开始绘制，相当于偏移。
        canvas.getContext("2d").drawImage(img, 0, 0);
        return canvas;
    },

    // 写入水印到Canvas
    addWatermark(canvas, text) {
        const ctx = canvas.getContext("2d");
        ctx.rotate((45 * Math.PI) / 180);
        let horizontal = ctx.canvas.width / 4;
        let vertical = ctx.canvas.height / 4;
        let fonstsize = ctx.canvas.width / 30;
        ctx.fillStyle = "#aaa";
        ctx.textBaseline = "middle";
        ctx.font = fonstsize + "px Arial";
        // ctx.textAlign = "center";
        // ctx.textBaseline = "middle";
        for (let i = 0; i <= 8; i++) {
            for (let j = 0; j <= 8; j++) {
                ctx.beginPath();
                ctx.fillText(
                    text,
                    i * horizontal - canvas.width / 2,
                    j * vertical - canvas.height / 2 - vertical * 2
                );
            }
        }
        return canvas;
    },

    // 把Canvas转换为image文件
    convasToImg(canvas, type) {
        // 新建Image对象，可以理解为DOM
        let image = new Image();
        // canvas.toDataURL 返回的是一串Base64编码的URL
        // 指定格式 PNG
        image.src = canvas.toDataURL(type);
        return image;
    },
    // 调用方法5：被image转换为File文件
    base64ToFile(urlData, fileName) {
        let arr = urlData.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let bytes = atob(arr[1]); // 解码base64
        let n = bytes.length;
        let ia = new Uint8Array(n);
        while (n--) {
            ia[n] = bytes.charCodeAt(n);
        }
        return new File([ia], fileName, {
            type: mime
        });
    },

}

export default util


// WEBPACK FOOTER //
// ./src/utils/util.js